import { prefectures } from '@/constants/prefecture';
import {
  Select,
  SelectContent,
  SelectTrigger,
  SelectValue
} from '@/components/shadcn/Select';

const findPrefectureName = (prefectureId: number) =>
  prefectures.find(({ id }) => id === prefectureId)?.name || '';

type Props = {
  value: number;
  onChange: (arg: number) => void;
  optionElements: JSX.Element[];
  placeholder: string;
  className: string;
};

export default function Prefecture({
  value,
  onChange,
  optionElements,
  placeholder,
  className
}: Props) {
  return (
    <Select
      value={value}
      onValueChange={(prefectureId: string) => onChange(Number(prefectureId))}
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder}>
          {findPrefectureName(value)}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>{optionElements}</SelectContent>
    </Select>
  );
}
